module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main